import { useState, useEffect } from "react";

export function useNotify(msg: string | null) {
  const [message, setErrorMsg] = useState(msg);

  const notify = (message: string | null) => {
    setErrorMsg(message);
    const timerId = setTimeout(() => {
      setErrorMsg(null);
    }, 2500);
    return () => {
      clearTimeout(timerId);
    };
  };

  useEffect(() => {
    if (msg) {
      notify(msg);
    }
  }, [msg]);

  return message;
}
